'use client';

import { SxProps, Theme, Typography } from '@mui/material';

interface SidebarSectionTitleProps {
  children: React.ReactNode;
  sx?: SxProps<Theme>;
}

export function SidebarSectionTitle({ children, sx }: SidebarSectionTitleProps) {
  return (
    <Typography
      sx={{
        fontSize: '0.75rem',
        fontWeight: 700,
        color: 'text.secondary',
        textTransform: 'uppercase',
        mb: 1,
        letterSpacing: '0.05em',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}
